import React from 'react';
import {
    Box,
    H1,
    Container,
    Grid,
    P,
} from '@saladbob/sassafras'

import getSite from '../../crud/getSite';
import getHofs from '../../crud/getHofs';
import HofCard from '../../components/hof/HofCard';
import Layout from '../../components/Layout';
import styles from './styles.module.css';

import type { NextPageWithLayout, PageProps } from '../_app';
import { Hof } from '../../types';

type Props = {
    Header: React.FC,
    years: string[],
    hofs: {
        [key:string]: Hof[],
    },
};

export async function getStaticProps() {
    const site = await getSite();
    const hofs = await getHofs(process.env.NEXT_PUBLIC_API_URL, { limit: 100, sort: '-year' });

    const hofsByYear = hofs.docs.reduce((acc, hof) => {
        const year = hof.year;
        if (!acc[year]) {
            acc[year] = [];
        }
        acc[year].push(hof);
        return acc;
    }, {});

    const years = Object.keys(hofsByYear).sort((a, b) => parseInt(b) - parseInt(a));

    return {
        props: {
            hofs: hofsByYear,
            years,
            ...site,
        },
    }
}

const Page: NextPageWithLayout<Props> = ({ hofs, years }) => {
    return (
        <Box bgColor="black" txtColor="white">
            <Box padding="xl">
                <Container size="lg">
                    <H1 font={{ phone: 'jumbo', laptop: 'giant' }} mb="0" color="primary">GUS MACKER</H1>
                    <H1 font="jumbo" mb="xl">Hall of Fame</H1>
                    <P font="leader">
                        The Gus Macker Hall of Fame is an esteemed institution dedicated to celebrating 
                        and immortalizing the basketball legends who have left an indelible mark on the world of
                        3 on 3 Gus Macker basketball. This Hall of Fame recognizes outstanding athletes, coaches, and 
                        influential figures who have contributed to the growth and success of this iconic 
                        grassroots sporting event. Enshrined within its hallowed walls are those whose passion, skill, 
                        and dedication have helped shape the Macker tournament into a beloved tradition, making 
                        them enduring icons of the sport.
                    </P>
                    {/* <Carousel columns={3} gap={32} mb="lg" dots buttons>
                        {hofs[years[years.length - 1]].map((hof) => <HofCard key={hof.id} hof={hof} />)}
                    </Carousel> */}
                    {years.map((year) => (
                        <Box mb="xxl" key={year}>
                            <Box style={{ overflow: 'hidden' }}>
                                <H1 display="inline-block" font="jumbo" mb="lg">
                                    {year}
                                    <Box
                                        bdWidth={['2px', 0, 0, 0]}
                                        bdColor="primary"
                                        ms="lg"
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '100%',
                                            width: '1000%',
                                        }}
                                    />
                                </H1>
                            </Box>
                            <Grid height="auto" minHeight="auto" className={styles.grid} gridGap="xl">
                                {hofs[year].map((hof) => <HofCard key={hof.id} hof={hof} />)}
                            </Grid>
                        </Box>
                    ))}
                </Container>
            </Box>
        </Box>
    );
};

Page.getLayout = function getLayout(page: React.ReactElement, pageProps: PageProps ) {
    return (
        <Layout { ...pageProps }>
            {page}
        </Layout>
    )
}

export default Page;